var exports = {
  "k": "xfd349460--6fe387--container",
};

module.exports = exports;
